//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyDepartureReport',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    label: function () {
      return this.tabProp.name
    },
    value: function () {
      return this.object[this.tabProp.key]
    },
    reportName: function () {
      return this.value && this.value.report && this.value.report.name || ''
    },
    reportURL: function () {
      if (this.value && this.value.report && this.value.request) {
        return '/task/' + this.value.request.id + '/document/' + this.value.report.id
      }
      return null
    }
  },
  created: function () {
  },
  methods: {
    onClick: function () {
      if (this.reportURL) {
        window.open(this.reportURL, '_blank')
      }
    }
  }
}
